import type { ReactNode } from "react";
import { BrandLogo } from "@/components/common/BrandLogo";
import { ThemeToggle } from "@/components/common/ThemeToggle";

interface AuthPageShellProps {
  children: ReactNode;
  showLogo?: boolean;
  showBeta?: boolean;
}

export function AuthPageShell({
  children,
  showLogo = true,
  showBeta = false,
}: AuthPageShellProps) {
  return (
    <main className="relative flex min-h-screen items-center justify-center overflow-hidden px-4 py-8">
      <div className="absolute right-4 top-4 z-20">
        <ThemeToggle />
      </div>
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_18%_20%,rgba(123,97,255,0.18),transparent_36%),radial-gradient(circle_at_84%_12%,rgba(63,146,255,0.15),transparent_34%)]" />
      <div className="hero-grain-overlay pointer-events-none absolute inset-0" />

      <div className="relative w-full max-w-md">
        {showLogo ? (
          <div className="mb-7 text-center">
            <BrandLogo size="lg" className="mx-auto" compact showBeta={showBeta} />
          </div>
        ) : null}
        {children}
      </div>
    </main>
  );
}

/** Minimal wrapper for auth-adjacent screens that don't use the full shell. */
export function AuthPageToggleFrame({ children }: { children: ReactNode }) {
  return (
    <div className="relative flex min-h-screen items-center justify-center p-6">
      <div className="absolute right-4 top-4 z-20">
        <ThemeToggle />
      </div>
      {children}
    </div>
  );
}
